import { TimeSlotHelper } from '../util/timeSlotHelper';
import { Deserializable } from './deserializable';
import { TimeSlot } from './timeSlot';
import * as moment from 'moment';
import { StringHelper } from '../util/stringHelper';
import { Log } from '../util/log';
import { DateHelper } from '../util/dateHelper';


export class Automation implements Deserializable {

  public static OperationTypeForcedLow: string = "ForceLow";

  public static ResultIdle: string = "Idle";
  public static ResultExecuting: string = "Executing";
  public static ResultExecuted: string = "Executed";
  public static ResultError: string = "Error";

  public static ErrorCannotStop: string = "cannot stop";


  id: number;
  serial: string;
  deviceReference: string;
  // operationType: string;
  number: number;
  result: string;
  timeZone: string;

  timeMask: string;
  // timeMask5min: string;
  dayMask: number;

  timeSlots: TimeSlot[] = [];
  daysAllowed: string = "";
  hoursAllowed: string = "";

  name: string;
  error: string;
  errorDescription: string;
  description: string;

  startDate: string;
  expirationDate: string;

  startDateDate: Date;
  expirationDateDate: Date;

  startDateFriendly: string;
  expirationDateFriendly: string;



  deserialize(input: any) {
    Object.assign(this, input);

    this.startDateDate = new Date(this.startDate);
    this.expirationDateDate = new Date(this.expirationDate);

    this.timeSlots = TimeSlotHelper.binaryStringToTimeSlots10min(this.timeMask);
    // this.timeSlots = TimeSlotHelper.binaryStringToTimeSlots5min(this.timeMask5min);è 

    this.timeZone = moment.tz.guess();

    if (this.result == Automation.ResultIdle) {
      this.result = $localize`:@@AutomationModel_result_idle:In attesa`;
    } else if (this.result == Automation.ResultExecuting) {
      this.result = $localize`:@@AutomationModel_result_executing:In esecuzione`;
    } else if (this.result == Automation.ResultExecuted) {
      this.result = $localize`:@@AutomationModel_result_executed:Eseguito`;
    } else if (this.result == Automation.ResultError) {
      //aggiungere traduzioni errori

      // if(this.errorDescription == Automation.ErrorCannotStop){
      //   this.result = $localize`:@@AutomationModel_result_error:Errore` + ": " + $localize`:@@AutomationModel_result_error_cannot_stop:Impossibile terminare`;
      // } else{
      //fallback errore non tradotto, da decidere se va lasciato
      this.result = $localize`:@@AutomationModel_result_error:Errore` + ": " + this.errorDescription;
      // }
    }
    // this.startDateFriendly = DateHelper.formatDateFriendly(this.startDateDate);
    // this.expirationDateFriendly = DateHelper.formatDateFriendly(this.expirationDateDate);

    this.startDateFriendly = DateHelper.formatDateTimeShortFriendly(this.startDateDate);
    this.expirationDateFriendly = DateHelper.formatDateTimeShortFriendly(this.expirationDateDate);

    this.getDaysAllowed();
    this.getHoursAllowed();
    return this;
  }


  isDayAllowed(dayOfWeek: number) {
    dayOfWeek = dayOfWeek - 1;

    return (this.dayMask & (1 << dayOfWeek)) == (1 << dayOfWeek);
  }

  getDayCheckedOrNot(dayOfWeek: number) {

    if (this.isDayAllowed(dayOfWeek)) {
      return "true";
    }
    else {
      return "false";
    }
  }

  getDaysAllowed() {
    this.daysAllowed = "";
    if (this.dayMask == 127) {
      this.daysAllowed = $localize`:@@automation_everyday2:Tutti i giorni`;
    } else if (this.isDayAllowed(1) && this.isDayAllowed(2) && this.isDayAllowed(3) && this.isDayAllowed(4) && this.isDayAllowed(5) && !this.isDayAllowed(6) && !this.isDayAllowed(7)) {
      this.daysAllowed = $localize`:@@automation_working_days:Giorni lavorativi (lun-ver)`;
    } else {
      if (this.isDayAllowed(1)) {
        this.daysAllowed = this.daysAllowed + $localize`:@@automation_monday_short:lun`;
      }
      if (this.isDayAllowed(2)) {
        if (this.daysAllowed != "") {
          this.daysAllowed = this.daysAllowed + ", ";
        }
        this.daysAllowed = this.daysAllowed + $localize`:@@automation_tuesday_short:mar`;
      }
      if (this.isDayAllowed(3)) {
        if (this.daysAllowed != "") {
          this.daysAllowed = this.daysAllowed + ", ";
        }
        this.daysAllowed = this.daysAllowed + $localize`:@@automation_wednesday_short:mer`;
      }
      if (this.isDayAllowed(4)) {
        if (this.daysAllowed != "") {
          this.daysAllowed = this.daysAllowed + ", ";
        }
        this.daysAllowed = this.daysAllowed + $localize`:@@automation_thursday_short:gio`;
      }
      if (this.isDayAllowed(5)) {
        if (this.daysAllowed != "") {
          this.daysAllowed = this.daysAllowed + ", ";
        }
        this.daysAllowed = this.daysAllowed + $localize`:@@automation_friday_short:ven`;
      }
      if (this.isDayAllowed(6)) {
        if (this.daysAllowed != "") {
          this.daysAllowed = this.daysAllowed + ", ";
        }
        this.daysAllowed = this.daysAllowed + $localize`:@@automation_saturday_short:sab`;
      }
      if (this.isDayAllowed(7)) {
        if (this.daysAllowed != "") {
          this.daysAllowed = this.daysAllowed + ", ";
        }
        this.daysAllowed = this.daysAllowed + $localize`:@@automation_sunday_short:dom`;
      }
      this.daysAllowed = this.daysAllowed.substr(0, 1).toUpperCase() + this.daysAllowed.substr(1);

    }
  }

  getHoursAllowed() {
    if (this.timeSlots.length == 0) {
      this.hoursAllowed = $localize`:@@automation_all_day:Tutto il giorno`;
    } else if (this.timeSlots.length == 1) {
      this.hoursAllowed = $localize`:@@automation_time_from:Dalle` + " " + this.timeSlots[0].getFromHourMin() + " " + $localize`:@@automation_time_to: alle` + " " + this.timeSlots[0].getToHourMin();
    } else {
      this.hoursAllowed = $localize`:@@automation_time_from:Dalle` + " " + this.timeSlots[0].getFromHourMin() + " " + $localize`:@@automation_time_to: alle` + " " + this.timeSlots[0].getToHourMin();
      for (let i = 1; i < this.timeSlots.length; i++) {
        this.hoursAllowed = this.hoursAllowed + ", " + $localize`:@@automation_time_from_lower_case:dalle` + " " + this.timeSlots[i].getFromHourMin() + " " + $localize`:@@automation_time_to: alle` + " " + this.timeSlots[i].getToHourMin();
      }
    }
  }


  public static createCopy(permission: Automation): Automation {

    let copyExecution: Automation = new Automation();

    copyExecution = Object.create(permission);

    if (!copyExecution.timeSlots) {

      copyExecution.timeSlots = TimeSlotHelper.binaryStringToTimeSlots10min(
        copyExecution.timeMask
      );

    } else {

      copyExecution.timeSlots = [];

      for (let slot of permission.timeSlots) {
        copyExecution.timeSlots.push(Object.create(slot));
      }
    }

    return copyExecution;
  }
}
